/**
 * The AI builder's starting designs (its `TemplateId`s). "Use this template" opens the builder on
 * the workspace's website with `?template=<id>`; the builder seeds a new project from it.
 */
import type { LucideIcon } from "lucide-react";
import { Briefcase, Building2, HeartHandshake, Palette, Rocket, UserRound } from "lucide-react";

export interface WebsiteTemplate {
  id: "portfolio" | "business" | "landing-page" | "professional-services" | "community" | "personal";
  name: string;
  category: string;
  description: string;
  icon: LucideIcon;
  /** Tailwind gradient for the preview tile. */
  tint: string;
}

export const TEMPLATES: WebsiteTemplate[] = [
  {
    id: "business",
    name: "Business",
    category: "Company website",
    description: "A professional site with services, team and a clear call to action.",
    icon: Building2,
    tint: "from-[#fde4d9] to-[#f6b9a3]",
  },
  {
    id: "landing-page",
    name: "Landing page",
    category: "Product or launch",
    description: "One high-impact page with benefits, pricing and sign-up.",
    icon: Rocket,
    tint: "from-[#fff1d6] to-[#f7cf86]",
  },
  {
    id: "professional-services",
    name: "Professional services",
    category: "Consultants, agencies, trades",
    description: "Services, credentials, testimonials and an enquiry form.",
    icon: Briefcase,
    tint: "from-[#e3efe9] to-[#a8d5c1]",
  },
  {
    id: "portfolio",
    name: "Portfolio",
    category: "Creatives",
    description: "Show your work with a clean, image-led layout.",
    icon: Palette,
    tint: "from-[#ece7f6] to-[#c5b5e6]",
  },
  {
    id: "community",
    name: "Community",
    category: "Clubs, charities, groups",
    description: "Events, membership and ways to get involved.",
    icon: HeartHandshake,
    tint: "from-[#e1eef8] to-[#a9cbe8]",
  },
  {
    id: "personal",
    name: "Personal",
    category: "Personal brand",
    description: "A simple home for your story, links and contact details.",
    icon: UserRound,
    tint: "from-[#f6ece4] to-[#dcc3ae]",
  },
];
